export default {
  title: {
    id: 'twofactor.title',
    defaultMessage: 'Please enter the One-Time Password to verify your account',
  },
  sentTo: {
    id: 'twofactor.sentTo',
    defaultMessage: 'A One-Time Password has been sent to {email}',
  },
  validate: {
    id: 'twofactor.validate',
    defaultMessage: 'Validate',
  },
  resend: {
    id: 'twofactor.resend',
    defaultMessage: 'Resend One-Time Password',
  },
  wrongNumber: {
    id: 'twofactor.wrongNumber',
    defaultMessage: 'Entered a wrong email?',
  },
};
